import { gql } from "@apollo/client"
import { ENTRY } from "./fields"

export const USER_ENTRY_UPDATE = fields => gql`
    fragment UserEntryUpdateItem on UserEntry {
        ${fields || ENTRY}
    }
`
